const mutations = {
  'SET_GROUPS' (state, value) {
    state.groups = value
  },
  'SET_GROUP' (state, value) {
    state.group = value
  }
}
export default mutations
